import { apiFGTS } from '../http/httpClient'
export interface createTransactionBody {
  value: number
  customerId: string
  CodigoTabela: string
  CodigoProduto: number
  CodigoEmpregador: number
  CodigoOrg: number
  Prazo: number
  pin?: string
}

interface createTransactionResponse {
  contract: string
  value: number
  status: string
  seller: string
  customer: string
  _id: string
  createdAt: string
  updatedAt: string
  __v: number
}
export async function createTransaction(body: createTransactionBody) {
  const { data } = await apiFGTS
    .post<createTransactionResponse>(`/transaction`, body)
    .catch((err) => {
      throw err?.response?.data || err
    })

  return data
}
